export function getAll() {
  const hasEnglish = window.localStorage["hasEnglish"] == "true";
  const hasJapanese = window.localStorage["hasJapanese"] == "true";
  const hasKorean = window.localStorage["hasKorean"] == "true";
  const hasFrench = window.localStorage["hasFrench"] == "true";

  let items = [
    {
      value: 0,
      name: "ZH",
      text: "中文(ZH)",
    },
  ];
  if (hasEnglish) {
    items.push({
      value: 1,
      name: "EN",
      text: "英文(EN)",
    });
  }
  if (hasJapanese) {
    items.push({
      value: 2,
      name: "JP",
      text: "日文(JP)",
    });
  }
  if (hasKorean) {
    items.push({
      value: 3,
      name: "KR",
      text: "韓文(KR)",
    });
  }
  if (hasFrench) {
    items.push({
      value: 4,
      name: "FR",
      text: "法文(FR)",
    });
  }
  return items;
}
